import { render, staticRenderFns } from "./RuleIndexView.vue?vue&type=template&id=6f9d6b1f&scoped=true"
import script from "./RuleIndexView.vue?vue&type=script&lang=js"
export * from "./RuleIndexView.vue?vue&type=script&lang=js"
import style0 from "./RuleIndexView.vue?vue&type=style&index=0&id=6f9d6b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d6b1f",
  null
  
)

export default component.exports